import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ordersService from "../services/Orders.Service";
export const getList = createAsyncThunk("orders/list", async ({data, type}, thunkAPI)=> {
  try{
    let listData = [];
    let pageData =  Object.assign({}, data)
    
    // if(pageData.page){
    //     pageData.page = pageData.page - 1  
    // }
    if(pageData.pageName !== "" && typeof pageData.pageName !== "undefined"){
      console.log(pageData.pageName)
      pageData.pageName  = 'getAllOrder'
      if(pageData.pageName === "/my-received-orders"){
        pageData.pageName = "getOrderTo"
      } else if(pageData.pageName === "/my-placeed-orders"){
        pageData.pageName  = 'getOrderFrom'
      }
      listData =  await ordersService.getList(pageData);
    }
    return listData;
  }catch(exception){
    if (!exception.response) {
      return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

export const getOrderById = createAsyncThunk("order/view", async (id, thunkAPI) => {
  try{
      const orderData =  await ordersService.getOrderById(id);
      return orderData;
  }catch(exception){
    if (!exception.response) {
      return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

export const updateOrder = createAsyncThunk("order/updateOrder", async (dataToSave, thunkAPI) => {
  try{
      const orderData =  await ordersService.updateOrder(dataToSave);
      return orderData;
  }catch(exception){
    if (!exception.response) {
      return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

export const createOrder = createAsyncThunk("order/createOrder", async (dataToSave, thunkAPI) => {
  try{
      const orderData =  await ordersService.createOrder(dataToSave);
      return orderData;
  }catch(exception){
    if (!exception.response) {
      return exception
    }
    return thunkAPI.rejectWithValue(exception?.response?.data)
  }
})

const initialState = {
  list: [],
  errors: false,
  success: false,
  loading: false,
  message: "",
  totalCount: 0,
  type: '',
  orderData: {}
}

const OrderSlice = createSlice({
  name: "order",
  initialState,
  reducers:{
    reset:(state,action) =>{
      if(Object.keys(action.payload) > 0){
        return {
          ...initialState,
          ...action.payload
        }
      }else{
        return  initialState
      }
    },
    resetApiStatus:(state) => {
      return {
          ...initialState,
          orderData: {},
          list: [],
          errors:false,
          success:false,
          loading:false,
          message:false
      }
    },
    checkGoods: ()=>{
        console.log("Goods Check")
      } 
    },
  extraReducers: {
    [getList.pending] : (state) => {
      state.loading = true
      state.errors = false
    },
    [getList.fulfilled] : (state, action) => {
      state.loading = false;
      state.totalCount = action.payload.totalDocs
      state.list = action.payload.docs; 
    },    
    [getList.rejected] : (state, action) => {
      state.loading = false;
      state.success = false
      state.message = action.payload.error.msg;
    },
    // Get By Order ID
    [getOrderById.pending] : (state) => {
      state.loading = true
      state.errors = false
    },
    [getOrderById.fulfilled] : (state, action) => {
      state.loading = false;
      state.orderData = action.payload.data
    },    
    [getOrderById.rejected] : (state, action) => {
      state.loading = false;
      state.success = false
      state.message = action.payload.error.msg;
    },
    //Update Order Status
    [updateOrder.pending]:(state,action) =>{
        state.loading = true
        state.type = "ORDER_UPDATE_LOADING"
    }
    ,
    [updateOrder.fulfilled]:(state,action) =>{
        state.loading = false
        state.success = true
        state.errors = false
        state.type = "ORDER_UPDATE_SUCCESS"
        state.message = action.payload.msg
    },
    [updateOrder.rejected]:(state,action) =>{
        state.loading = false
        state.success = false
        state.errors = true
        state.type = "ORDER_UPDATE_ERROR"
        state.message = action.payload.message
    },
    //Created Order
    [createOrder.pending]:(state,action) =>{
      state.loading = true;
      state.type = "ORDER_CREATE_LOADING";
    },
    [createOrder.fulfilled]:(state,action) =>{
        state.loading = false;
        state.success = action.payload.status;
        state.errors = !action.payload.status;
        state.type = "ORDER_CREATE_SUCCESS";
        state.message = action.payload.msg;
    },
    [createOrder.rejected]:(state,action) =>{
        state.loading = false;
        state.success = false;
        state.errors = true;
        state.type = "ORDER_CREATE_ERROR";
        state.message = action.payload.msg;
    }
  }
})
export const { reset, resetApiStatus } = OrderSlice.actions;
export default OrderSlice.reducer 